import { render, staticRenderFns } from "./pad-separator.vue?vue&type=template&id=f586035c&scoped=true&"
import script from "./pad-separator.vue?vue&type=script&lang=js&"
export * from "./pad-separator.vue?vue&type=script&lang=js&"
import style0 from "./pad-separator.vue?vue&type=style&index=0&id=f586035c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f586035c",
  null
  
)

export default component.exports